import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { MessageContext } from '../Framework/Context/MessageContext';

const useDeleteEntity = ({ service, resource, onSuccess }) => {
    const { t } = useTranslation();
    const { pushMessage } = useContext(MessageContext);
    const [markedForDeletion, setMarkedForDeletion] = useState(null);
    const [error, setError] = useState(null);
    const [isDeleting, setIsDeleting] = useState(false);

    const markForDeletion = (entity) => {
        setError(null);
        setMarkedForDeletion(entity);
    };

    const clearMarkedForDeletion = () => {
        setMarkedForDeletion(null);
        setError(null);
    };

    const translateError = (requestError) =>
        t(`application.${requestError?.response?.data?.message}`, {
            resource: t(`application.${resource}`),
            defaultValue: t('application.delete_error'),
        });

    const handleSuccess = (entity) => {
        clearMarkedForDeletion();
        pushMessage({ title: t('application.delete_success') });
        onSuccess(entity);
    };

    const confirmDelete = () => {
        const entity = markedForDeletion;
        setIsDeleting(true);
        service
            .remove(resource, entity.id)
            .finally(() => setIsDeleting(false))
            .then(
                () => handleSuccess(entity),
                (requestError) => setError(translateError(requestError)),
            );
    };

    return {
        markedForDeletion,
        markForDeletion,
        clearMarkedForDeletion,
        confirmDelete,
        error,
        isDeleting,
    };
};

export default useDeleteEntity;
